<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">Contratos</span>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>CONTRATOS ASSOCIADOS</b-alert>
                        <app-tabela
                            idTbela="tb1Contratos"
                            :itens="usuario.contratos"
                            :campos="camposContratos"
                            :itensPorPagina="0"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="danger"
                                        v-if="$temAcessoView('CTRLACS-USR-07-03')"
                                        @click="confirmaDesassociarSelecionados()"
                                        :disabled="contratosAssociadosSelecionados.length === 0"
                                    >
                                    Dessassociar selecionados
                                    </b-button>
                                </b-button-group>
                            </template>
                            <template
                                slot="contratoAssociadoSelecao" 
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-USR-07-03')"
                            >
                                <b-form-checkbox
                                    :value="data.vcCodigoEstruturado"
                                    v-model="contratosAssociadosSelecionados"
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                    <b-col sm="12" md="6" lg="6" xl="6">
                        <b-alert show>CONTRATOS DISPONÍVEIS</b-alert>
                        <app-tabela
                            idTabela="tb1ContratosDisponiveis"
                            :itens="contratosDisponiveis"
                            :campos="camposContratosDisponiveis"
                            :itensPorPagina="0"
                        >  
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        v-if="$temAcessoView('CTRLACS-USR-07-02')"
                                        @click="confirmaAssociarSelecionados()"
                                        :disabled="contratosDisponiveisSelecionados.length === 0"
                                    >
                                    Associar Selecionados
                                    </b-button>
                                </b-button-group>
                            </template>
                            <template
                                slot="contratoDisponivelSelecao"
                                slot-scope="data"
                                v-if="$temAcessoView('CTRLACS-USR-07-02')"
                            >
                                <b-form-checkbox
                                    :value="data.vcCodigoEstruturado"
                                    v-model="contratosDisponiveisSelecionados"
                                ></b-form-checkbox>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'

export default {
    props: {
        usuario: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            contratos: [],
            contratosDisponiveisSelecionados: [],
            contratosAssociadosSelecionados: [],
            camposContratos: [
                {
                    key: 'contratoAssociadoSelecao',
                    label: ''
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                }
            ],
            camposContratosDisponiveis: [
                {
                    key: 'contratoDisponivelSelecao',
                    label: ''
                },
                {
                    key: 'vcCodigoEstruturado',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'fornecedor',
                    label: 'Fornecedor',
                    sortable: true,
                    filterable: true
                }
            ]
        }
    },

    methods: {
        obterContratos() { 
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterContratos().then(response => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
            })
            this.$store.dispatch('removeRequest')
        },

        confirmaAssociarSelecionados(){
            this.$swal({
                title: 'Associação de Contratos',
                html: `Confirma a associação dos contratos selecionados ao usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.associarContratos()
                }
            })
        },

        associarContratos() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.associarContrato({
                usuarioId: this.$route.params.usuarioId,
                codigosContratos: this.contratosDisponiveisSelecionados
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro salvo com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.contratosDisponiveisSelecionados = []
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmaDesassociarSelecionados(){
            this.$swal({
                title: 'Desassociação de Contratos',
                html: `Confirma a desassociação dos contratos selecionados do usuário <b>${this.usuario.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociarPerfisAcesso()
                }
            })
        },

        desassociarPerfisAcesso(){
            this.$store.dispatch('addRequest')
            UsuariosServicos.desassociarContrato({
                usuarioId: this.$route.params.usuarioId,
                codigosContratos: this.contratosAssociadosSelecionados
            }).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registros desassociados com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.contratosAssociadosSelecionados = []
                        this.$emit('obterUsuario')
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    created() {
        this.obterContratos()
    },

    computed: {
        contratosDisponiveis() {
            if (this.usuario.contratos) {
                return this.contratos.filter(contrato => {
                    return this.usuario.contratos.every(usuarioContrato => {
                        return usuarioContrato.vcCodigoEstruturado !== contrato.vcCodigoEstruturado
                    })
                })
            }
        }
    },

    watch: {
    }
}
</script>
